class ReportTemplateModel extends App.Models.BaseModel {
    modelUrl = 'ReportTemplate';
}

App.Models.ReportTemplate = ReportTemplateModel;
